export default [
  {
    path: "/app/rank",
    name: "Rank",
    meta: {
      title: "Rank",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/rank.vue")
  },
  {
    path: "/app/rankList",
    name: "RankList",
    meta: {
      title: "rankList",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/app/rankList.vue")
  },
];
//抢购
